module.exports = __webpack_public_path__ + "static/media/rum.21d3707d.mp3";